var map = {
	"./KUCE-01.png": "8e54",
	"./KUCE-02.png": "75f5",
	"./KUCE-03.png": "bd37",
	"./KUCE-04.png": "ef6b",
	"./KUCE-05.png": "1d54",
	"./KUCE-06.png": "ec90",
	"./KUCE-07.png": "6659",
	"./KUCE-08.png": "127a",
	"./KUCE-09.png": "3a74",
	"./KUCE-10.png": "d726"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fae0";